<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les Enseignants" />
            <LesProfesseurs/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesProfesseurs from './LesProfesseurs.vue'


export default {
    name: 'MouvementPage',
    components: {
        NavBar,
        PageTitle,
        LesProfesseurs,
        FooterComp,
    }
}
</script>